import{hostReportError as r}from"./hostReportError.js";var n=function(n){return function(t){return n.then((function(r){t.closed||(t.next(r),t.complete())}),(function(r){return t.error(r)})).then(null,r),t}};export{n as subscribeToPromise};
